@if (expandMenuDrawer$ | async) {}
<div
  zSideDrawer
  [isOpen]="isOpen()"
  [direction]="'right'"
  [maxWidth]="this.maxWidth()"
>
  <ng-content select="top-header-filters-section-mobile" />
</div>
